import { compose } from 'redux';
import Moment from 'moment';
// mui
import { Box } from '@mui/material';
import { withStyles } from '@mui/styles';
// components
import { useFeatureIsOn } from '@growthbook/growthbook-react';
import withRouter from '../../components/hocs/withRouter';
import { withBackfill } from '../../components/hocs/withBackfill';
import { UrlDateRangePicker } from '../../components/inputs/DateRangePicker';
import CFHistory from './CFHistory';
import { AiCFHistory } from './AiCFHistory';
import CFCharts from './CFCharts';
import RiskReportCardContainer from '../../console/_tabs/riskTab/RiskReportCard/RiskReportCardContainer';

import { TabbedReasonsRecommendations } from './TabbedReasonsRecommendations';
import { ReasonsRecommendations } from './ReasonsRecommendations';

import { useActor } from '../../components/hooks/useActor';
import { FEATURE_FLAG_KEYS } from '../../config/growthbook';

const styles = ({ palette }: any) => ({
  dropdown: {
    margin: '0.5rem 0 0 2rem',
    width: '25rem',
  },
  button: {
    padding: '5px !important',
    border: `1px solid ${palette.primary.oldBorder2}`,
  },
  headerDateRangeComboContainer: {
    display: 'flex',
    flexDirection: 'row',
  },
});

// ui
const InsightsContainer = compose(
  withRouter,
  withBackfill('uiSettings.insights', {
    size: '25',
    order: 'desc',
    orderBy: 'created',
    before: Moment().unix(),
    after: Moment().subtract(6, 'months').unix(),
  }),
  // @ts-expect-error TS(2345): Argument of type '({ palette }: any) => { dropdown... Remove this comment to see the full error message
  withStyles(styles, { withTheme: true })
)(({ classes, q }: any) => {
  const actor = useActor();
  const showRiskReportDownload = useFeatureIsOn(
    FEATURE_FLAG_KEYS.SHOW_RISK_REPORT_DOWNLOAD
  );
  const isSpotlightV2Enabled = useFeatureIsOn(FEATURE_FLAG_KEYS.SPOTLIGHT_V2);

  return (
    <section className={classes.mainContainer}>
      <section>
        <div
          className="flex--spaced"
          style={{ marginBottom: 15, alignItems: 'baseline' }}
        >
          <h1 className="table-heading" style={{ marginTop: 0 }}>
            Insights
          </h1>

          <div className="flex--spaced">
            <UrlDateRangePicker
              q={q}
              sort="created"
              maxSelectableDate={new Date('2023-12-31')}
              inlineLabel
            />
          </div>
        </div>

        {showRiskReportDownload && (
          <Box mb="1.25rem">
            <RiskReportCardContainer accountId={actor.account.id} />
          </Box>
        )}
      </section>
      <CFHistory q={q} accountId={actor.account.id} />
      <AiCFHistory accountId={actor.account.id} />
      <CFCharts q={q} accountId={actor.account.id} />
      {isSpotlightV2Enabled ? (
        <TabbedReasonsRecommendations q={q} accountId={actor.account.id} />
      ) : (
        <ReasonsRecommendations q={q} accountId={actor.account.id} />
      )}
    </section>
  );
});

export default InsightsContainer;
